<template>
  <v-container text-xs-center>
    <v-card class="elevation-5">
      <!-- Styled Tabs Container -->
      <div class="tabs-container">
        <v-tabs
          v-model="tab"
          dark
          background-color="light-blue darken-4"
          show-arrows
          class="centered-tabs"
        >
          <!-- <v-tab :value="'meetReport'">Meet Report</v-tab>
          <v-divider vertical class="tab-divider" /> -->
          <v-tab :value="'groups'">Groups</v-tab>
          <v-divider vertical class="tab-divider" />
          <v-tab :value="'groupProgram'">Group Program</v-tab>
          <v-divider vertical class="tab-divider" />
          <v-tab :value="'workoutSchedule'">Workout Schedule</v-tab>
          <v-divider vertical class="tab-divider" />
          <v-tab :value="'records'">Records</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <!-- Meet Report -->
          <!-- <v-tab-item key="meetReport">
            <v-card>
              <v-layout>
                <v-flex xs2 lg2>
                  <v-autocomplete
                    v-model="athleteId"
                    :rules="athleteRules"
                    required
                    :hint="`${athleteId}`"
                    label="Select Athlete Name"
                    :items="getAthletes()"
                    item-value="athleteId"
                    :item-text="text"
                  >
                  </v-autocomplete>
                </v-flex>
              </v-layout>
              <v-flex>
                <athleteResults />
              </v-flex>
              <v-flex>
                <athleteRanks />
              </v-flex>
            </v-card>
          </v-tab-item> -->

          <!-- Groups -->
          <v-tab-item key="groups">
            <groups />
          </v-tab-item>

          <!-- Group Program -->
          <v-tab-item key="groupProgram">
            <groupProgram />
          </v-tab-item>

          <!-- Workout Schedule -->
          <v-tab-item key="workoutSchedule">
            <workoutSchedule />
          </v-tab-item>

          <!-- Records -->
          <v-tab-item key="records">
            <records />
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-card>
  </v-container>
</template>
<script>
//import athleteAttendance from "./AthleteAttendance.vue";

// import athleteResults from "./AthleteResults.vue";
// import athleteRanks from "./AthleteRanks.vue";
import groupProgram from "./GroupProgram.vue";
import workoutSchedule from "./WorkoutSchedule.vue";
import groups from "./GroupList.vue";
import records from "../league/Records.vue";
//import athleteList from "./AthleteList.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    //athleteAttendance,
    // athleteResults,
    // athleteRanks,
    groups,
    groupProgram,
    workoutSchedule,
    records
    //clubGroups
    //athleteList
    // SheetFooter: {
    //   functional: true,

    //   render(h, { children }) {
    //     return h(
    //       "v-sheet",
    //       {
    //         staticClass: "mt-auto align-center justify-center d-flex",
    //         props: {
    //           color: "rgba(0, 0, 0, .36)",
    //           dark: true,
    //           height: 50
    //         }
    //       },
    //       children
    //     );
    //   }
    // }
  },
  data() {
    return {
      tab: "groups",
      isFormValid: true,
      status: "active",
      search: "",
      athleteId: "",
      athleteRules: [v => !!v || "Athlete is required"]
    };
  },
  created() {
    this.handleGetAthleteResults();

    //this.handleGetAthleteList();
  },
  watch: {
    tab(newTab) {
      if (this.$route.query.tab !== newTab) {
        this.$router.replace({
          name: this.$route.name,
          params: this.$route.params,
          query: { tab: newTab }
        });
      }
    }
  },
  computed: {
    ...mapGetters(["loading", "athleteList", "athleteResults"]),
    text() {
      return item => `${item.firstName} ${item.lastName}`;
    }
  },
  methods: {
    updateTabQuery(tabName) {
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: { tab: tabName } // don't keep old query keys
      });
    },
    onTabChange(newTab) {
      this.replaceWithTabQuery(newTab);
    },
    replaceWithTabQuery(tabName) {
      // Replace entire query string with only ?tab=...
      this.$router.replace({
        path: this.$route.path,
        query: {
          tab: tabName
        }
      });
    },
    handleGetAthleteResults() {
      //reach out of Vuex store, fire action that gets posts for carousel
      if (
        this.athleteResults === undefined ||
        this.athleteResults.length == 0
      ) {
        this.$store.dispatch("allResults", {
          clubId: this.$route.params.club
        });
      }
    },
    getAthletes: function() {
      return Array.from(
        new Set(this.athleteResults.edges.map(item => item.node.athleteId))
      ).map(athleteId => {
        return {
          athleteId: athleteId,
          firstName: this.athleteResults.edges.find(
            item => item.node.athleteId === athleteId
          ).node.athlete.firstName,
          lastName: this.athleteResults.edges.find(
            item => item.node.athleteId === athleteId
          ).node.athlete.lastName
        };
      });
    }
  },
  mounted() {
    const validTabs = [
      // "meetReport",
      "groups",
      "groupProgram",
      "workoutSchedule",
      "records"
    ];
    const queryTab = this.$route.query.tab;

    if (queryTab && validTabs.includes(queryTab)) {
      this.tab = queryTab;
    } else {
      this.tab = "meetReport";
      this.$router.replace({
        ...this.$route,
        query: {
          ...this.$route.query,
          tab: "meetReport"
        }
      });
    }
  }
};
</script>
<style>
.centered-tabs {
  justify-content: center;
}

.tab-divider {
  margin: 0 8px;
  align-self: center;
}
</style>
